import React, { useState } from 'react';
import BEM from '../../bem';
import { ReactComponent as CircledCheckMarkIcon } from '../../../common/images/circled-checkmark.svg';
import DotsIndicator from '../DotsIndicator';
import TaskCard from './TaskCard';
import { useAppSelector } from 'redux-stores';
import { useGetTasksQuery } from 'redux-stores/tasks/tasksApi';
import type { Task } from 'js-sdk/src/types/Tasks';

const classes = BEM.with('TasksListView');

type Filter = 'active' | 'completed';

function EmptyState() {
  return (
    <div className={classes('empty')} data-test-id="tasks-empty-state">
      <CircledCheckMarkIcon aria-hidden className={classes('empty-icon')} />
      <span className={classes('empty-text')}>No tasks found</span>
    </div>
  );
}

function TasksListView() {
  const [filter, setFilter] = useState<Filter>('active');
  const organizationId = useAppSelector((state) => state.session.currentOrganizationId);
  const { data: tasks = [], isLoading } = useGetTasksQuery(organizationId ?? '', {
    skip: !organizationId,
  });

  const filtered = tasks.filter((t: Task) =>
    filter === 'active' ? t.status === 'open' : t.status === 'completed'
  );

  return (
    <div className={classes('')} data-test-id="tasks-list-view">
      <div className={classes('header')}>
        <CircledCheckMarkIcon aria-hidden className={classes('header-icon')} />
        <h2 className={classes('title')}>Tasks</h2>
        <div className={classes('toggle')} data-test-id="tasks-filter-toggle">
          <button
            className={classes('toggle-btn', { active: filter === 'active' })}
            onClick={() => setFilter('active')}
            type="button"
          >
            Active
          </button>
          <button
            className={classes('toggle-btn', { active: filter === 'completed' })}
            onClick={() => setFilter('completed')}
            type="button"
          >
            Completed
          </button>
        </div>
      </div>
      {isLoading ? (
        <div className={classes('loading')}>
          <DotsIndicator />
        </div>
      ) : filtered.length === 0 ? (
        <EmptyState />
      ) : (
        <div className={classes('list')}>
          {filtered.map((task: Task) => (
            <TaskCard key={task.id} organizationId={organizationId ?? ''} task={task} />
          ))}
        </div>
      )}
    </div>
  );
}

export default TasksListView;
